export default "https://cdn1.saucelabs.com/web-ui/images/assets/3b38ac3f083258d39ff1fb1014e17eaa.png";